import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useOrderPaymentListQuery } from "Order/Modules/Payment/Api/Query/useOrderPaymentListQuery";
import { AddPaymentForm } from "Order/Modules/Payment/Components/Forms/AddPaymentForm";
import { EditPaymentForm } from "Order/Modules/Payment/Components/Forms/EditPaymentForm";
import { Alert } from "Shared/Components/Alert";
import { Loading } from "Shared/Components/Loading/Loading";
import { Box, Divider, Stack, Typography } from "@mui/material";

type PaymentFormTabProps = {
	orderId: number;
};

const paymentResource = Resources.base.payment.shared;

export function PaymentFormTab({ orderId }: PaymentFormTabProps) {
	const { t } = useResource();
	const {
		data: payments,
		isLoading,
		isFetching,
	} = useOrderPaymentListQuery(orderId);

	return (
		<Box px={3}>
			<Typography variant="h5">{t(paymentResource.addPayment)}</Typography>
			<AddPaymentForm orderId={orderId} />
			<Divider sx={{ my: 2 }} />
			<Typography variant="h5">{t(paymentResource.paymentDetails)}</Typography>

			{payments && payments?.length > 0 ? (
				<Stack spacing={3} mt={2}>
					{payments.map((payment) => (
						<EditPaymentForm
							key={payment.id}
							payment={payment}
							orderId={orderId}
						/>
					))}
				</Stack>
			) : (
				!isLoading &&
				!isFetching && (
					<Alert
						message={"This order has no payments yet"}
						color="grey"
						sx={{ marginTop: 1 }}
					/>
				)
			)}
			{(isLoading || isFetching) && (
				<Stack width="100%" alignItems="center">
					<Loading />
				</Stack>
			)}
		</Box>
	);
}
